import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { debounce } from "lodash";
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isCollapsed: true,
      quickTags: [],
      searchResults: [],
      langOpt: [{
        value: "zh",
        label: "简体"
      }, {
        value: "en",
        label: "英文"
      }, {
        value: "tw",
        label: "繁体"
      }],
      form: {
        language: "zh",
        categoryId: "",
        keywords: ""
      },
      loading: false
    };
  },
  created: function created() {
    this.getTagList();
    this.search();
  },
  mounted: function mounted() {
    // 添加全局点击监听
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁时移除监听
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    //点击元素以外收起浮窗
    handleClickOutside: function handleClickOutside(event) {
      var popup = document.querySelector(".common-reply");
      if (popup && !popup.contains(event.target)) {
        this.isCollapsed = true;
      }
    },
    search: debounce(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this = this;
      var res;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            this.loading = true;
            _context.n = 1;
            return this.$api.advisorySearch(this.form);
          case 1:
            res = _context.v;
            res.data && (this.searchResults = res.data);
            this.searchResults.forEach(function (i) {
              i.question = _this.highlightKeyword(i.question);
              i.content = i.answer;
              i.content = _this.highlightKeyword(i.content);
            });
            this.loading = false;
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    })), 300),
    changeCollapse: function changeCollapse(flg) {
      this.isCollapsed = flg;
    },
    handleTagClick: function handleTagClick(val) {
      if (this.form.categoryId === val) {
        this.form.categoryId = "";
        return this.search();
      }
      this.form.categoryId = val;
      this.search();
    },
    selectAnswer: function selectAnswer(item) {
      this.$emit("select", item.answer || "", item.id);
    },
    getTagList: function getTagList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getFaqList();
            case 1:
              res = _context2.v;
              res.data && (_this2.quickTags = res.data);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    highlightKeyword: function highlightKeyword(text) {
      if (!this.form.keywords) return text;
      var reg = new RegExp(this.form.keywords, "gi");
      return text.replace(reg, function (match) {
        return "<span style=\"color: #2DB6B6\">".concat(match, "</span>");
      });
    }
  }
};